import angular from 'angular';
import './restaurantInfo.scss';

import { ModifyOrderModalComponent } from './modify_order_modal.component';
import { OrderSummaryComponent } from './order_summary.component';

export const RestaurantInfoModule = angular
    .module('oo.common.restaurantInfo', [])
    .component('modifyOrderModal', ModifyOrderModalComponent)
    .component('orderSummary', OrderSummaryComponent)
    .name;
